import { useCallback, useState } from "react";
import { ISubscriptionCreateRequest } from "../../interfaces/ISubscriptionCreateRequest";
import { useConsumerController } from "../useConsumerController/useConsumerController";
import { useAdminController } from "../useAdminController/useAdminController";
import { useAuthenticationContext } from "../../context/authenticationContext/authenticationContext";

export const usePatchSubscription = (): [
  any | undefined,
  boolean,
  Error | undefined,
  (
    consumerId: string,
    subscriptionId: string,
    subscriptionPatchRequest: Omit<ISubscriptionCreateRequest, "producerId">,
    isAdmin: boolean
  ) => Promise<any>
] => {
  const [data, setData] = useState<any>();
  const { user } = useAuthenticationContext();
  const { patch: consumerPatch, response: consumerResponse, loading: consumerLoading, error: consumerError } = useConsumerController<any>(false);
  const { patch: adminPatch, response: adminResonse, loading: adminLoading, error: adminError } = useAdminController<any>(user ?? undefined);

  const patchConsumer = useCallback(
    async (
      consumerId: string,
      subscriptionId: string,
      subscriptionPatchRequest: Omit<ISubscriptionCreateRequest, "producerId">,
      isAdmin: boolean
    ) => {
      const patch = isAdmin ? adminPatch : consumerPatch;

      const consumer = await patch(
        `${
          isAdmin ? "/consumers" : ""
        }/${consumerId}/subscriptions/${subscriptionId}`,
        subscriptionPatchRequest
      );

      setData(consumer);

      return consumer;
    },
    [consumerPatch, adminPatch]
  );

  return [data, consumerLoading || adminLoading, consumerError || adminError, patchConsumer];
};
